import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class PaginatorIntl extends MatPaginatorIntl {
  override nextPageLabel = 'siguiente';
  override previousPageLabel = 'anterior';
  override itemsPerPageLabel = 'items por página';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const maxLength = Math.max(length, 0);
    const startIndex = page * pageSize;

    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, maxLength)
        : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} de ${maxLength}`;
  };
}
